import AdvertisizingIcon from '@/CustomIcons/Gradient/AdvertisizingIcon'
import EducationIcon from '@/CustomIcons/Gradient/EducationIcon'
import FilmIcon from '@/CustomIcons/Gradient/FilmIcon'
import MusicNoteIcon from '@/CustomIcons/Gradient/MusicNoteIcon'
import OtherIcon from '@/CustomIcons/Gradient/OtherIcon'
import PodcastingIcon from '@/CustomIcons/Gradient/PodcastingIcon'

export const other = {
    label: 'Other',
    value: 'other',
    icon: OtherIcon,
}

export const industries = [
    {
        label: 'Music',
        value: 'music',
        icon: MusicNoteIcon,
    },
    {
        label: 'Film',
        value: 'film',
        icon: FilmIcon,
    },
    {
        label: 'Advertising',
        value: 'advertising',
        icon: AdvertisizingIcon,
    },
    {
        label: 'Education',
        value: 'education',
        icon: EducationIcon,
    },
    {
        label: 'Podcasting',
        value: 'podcasting',
        icon: PodcastingIcon,
    },
]

export const useCases = [
    {
        label: 'Freelance work',
        value: 'freelance',
    },
    {
        label: 'Education',
        value: 'education',
    },
    {
        label: 'Music production',
        value: 'production',
    },
    {
        label: 'Real-time jamming',
        value: 'jamming',
    },
    {
        label: 'Recording',
        value: 'recording',
    },
    {
        label: 'Audio engineering',
        value: 'engineering',
    },
    {
        label: 'Sound design',
        value: 'design',
    },
    {
        label: 'Songwriting',
        value: 'songwriting',
    },
    {
        label: 'Composing',
        value: 'composing',
    },
    {
        label: 'Voice acting',
        value: 'actor',
    },
    {
        label: 'Audio editing (film)',
        value: 'film-editing',
    },
    {
        label: 'Video conferencing',
        value: 'conferencing',
    },
]

export const roles = [
    {
        label: 'Artist',
        value: 'artist',
    },
    {
        label: 'Audio engineer',
        value: 'engineer',
    },
    {
        label: 'Composer',
        value: 'composer',
    },
    {
        label: 'Freelancer',
        value: 'freelancer',
    },
    {
        label: 'Producer',
        value: 'producer',
    },
    {
        label: 'Musician',
        value: 'musician',
    },
    {
        label: 'Podcaster',
        value: 'podcaster',
    },
    {
        label: 'Songwriter',
        value: 'songwriter',
    },
    {
        label: 'Student',
        value: 'student',
    },
    {
        label: 'Teacher',
        value: 'teacher',
    },
    {
        label: 'Vocalist',
        value: 'vocalist',
    },
    {
        label: 'Voice actor',
        value: 'actor',
    },
]
